import { CountriesResponse } from '@/infrastructure/network/dto/CountryDto';

export const countriesDtoToCountries = (countriesDto: CountriesResponse): CountriesResponse => {
	return {
		results: countriesDto.results.map((country) => ({
			id: country.id,
			abbreviation: country.abbreviation,
			title: country.title,
			internationalCountryCallingCode: country.internationalCountryCallingCode,
			stateTitle: country.stateTitle,
			zipCodeTitle: country.zipCodeTitle,
			systemTextNumberId: country.systemTextNumberId,
			abbreviation2Digit: country.abbreviation2Digit,
			displayOrder: country.displayOrder,
			isEnabled: country.isEnabled,
			regionType: country.regionType,
			regionId: country.regionId
		}))
	};
};
